module.exports = __webpack_public_path__ + "img/magento-setup-tuning_small@2x.c6de077d.webp";